import css from 'styled-jsx/css';

const staticStyles = css`
  #telegramAuthWrapper {
    text-align: center;
  }
`;

export { staticStyles };
